// Mobile menu functionality
(function () {
    const header = document.querySelector('.thread-header');
    const menuToggle = document.querySelector('.mobile-menu-toggle');
    const overlay = document.querySelector('.mobile-menu-overlay');
    const mobileSearchBtn = document.querySelector('.mobile-search-button');
    
    // Toggle mobile menu
    if (menuToggle) {
        menuToggle.addEventListener('click', function (e) {
            e.stopPropagation();
            header.classList.toggle('menu-active');
            
            // Prevent body scroll when menu is open
            if (header.classList.contains('menu-active')) {
                document.body.style.overflow = 'hidden';
            } else {
                document.body.style.overflow = '';
            }
        });
    }
    
    // Close menu when clicking overlay
    if (overlay) {
        overlay.addEventListener('click', function (e) {
            if (e.target === overlay) {
                header.classList.remove('menu-active');
                document.body.style.overflow = '';
            }
        });
    }
    
    // Mobile dropdown toggle
    const dropdownToggles = document.querySelectorAll('.mobile-dropdown-toggle');
    dropdownToggles.forEach(function (toggle) {
        toggle.addEventListener('click', function () {
            const parent = this.closest('.mobile-dropdown');
            parent.classList.toggle('active');
        });
    });
    
    // Mobile search button
    if (mobileSearchBtn) {
        mobileSearchBtn.addEventListener('click', function () {
            const searchToggle = document.querySelector('.desktop-nav .gh-search');
            if (searchToggle) {
                searchToggle.click();
            }
        });
    }
    
    // Close menu on link click
    const mobileLinks = document.querySelectorAll('.mobile-nav a');
    mobileLinks.forEach(function (link) {
        link.addEventListener('click', function () {
            header.classList.remove('menu-active');
            document.body.style.overflow = '';
        });
    });
})();